import { Component, OnInit } from '@angular/core';
import { AuthService } from './../auth/auth.service';
import { Observable, map } from 'rxjs';
import { Router } from '@angular/router';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { DialogOverviewExampleDialogComponent } from '../dialog-overview-example-dialog/dialog-overview-example-dialog.component';

@Component({
  selector: 'app-activatecost',
  templateUrl: './activatecost.component.html',
  styleUrls: ['./activatecost.component.css'],
})
export class ActivatecostComponent implements OnInit {
  modval: any;
  rewval: any;
  message: string;
  buildEnv: any;
  lightData: any;
  hvData: any;
  selectedIndexo = 0;
  newselectedIndex = 0;
  solarYn;
  contedit: boolean;
  solarYesNO;
  solarYesNOToggle: boolean;
  btntxt: string = 'Load all WINDOW';
  heatEffectCost;
  coolEffectCost;
  newpvValue;
  neweffValue;
  newwindValue;
  solarYnWin = 'Yes';
  newheatEff;
  newcoolEff;
  freshAir: any;
  freshAirList;
  contentEditableRen;
  contentEditableWin;
  WindEnabled;
  SolarEnabled;
  SolarChanged;
  WindChanged;
  HeatEffChanged;
  CostChanged = 'N';
  condId;
  newUserId;
  newProjId;
  newEventId;
  BuildEnvCost;
  disbwall;
  disbwallN;
  disbwallNR;
  disbwallR;
  disbwallF;
  disbwallNF;
  disbwallNW;
  disbwallS;
  disbwallW;
  lightDataCost;
  disbwallL;
  disbwallNL;
  disbwallD;
  hvDataCost;
  disbHvacAsh;
  disbHvacNec;
  rootDomainUrl;
  orgidfirst;
  newboilerCOP;
  ashraewall;
  necbwall;
  ashraeroof;
  necbroof;
  ashraefloor;
  necbfloor;
  animal: string;
  name: string;
  w1;
  w2;
  w3;
  w4;
  w5;
  w6;
  w7;
  r1;
  r2;
  r3;
  r4;
  r5;
  f1;
  f2;
  f3;
  toggleStatusNew;
  toggleStatusNewWind;
  isUpdated: boolean = false;
  recCount;
  percent;
  time;
  selectedIndex;
  lumpsum;
  wall;
  newToggleEditable = 'true';
  newcustBase;
  newcustBaseRoof;
  newcustBaseFloor;
  newcustBaseWindow;
  newcustBaseShading;
  newcustBaseLighting;
  newcustBaseWwr;
  newcustDaylight;
  newcustBaseHvac;
  newcustBaseHeatRec;
  newcustBaseDl;
  toggleStatusNewDhw;
  isDhwEnabled;
  keycount: any = 0;
  defv;
  newEmail;
  messagenew;
  orgidsecond;
  orgidthird;
  orgidfourth;
  orgidfifth;
  orgidsix;
  orgidseven;
  orgideight;
  orgidnine;
  orgIdInf;
  demo_user_id = '5';
  demo_proj_id = '220';
  orgidten;
  hvDataPrimary = [];
  hvDataSec = [];
  frAirCbPrim = '';
  frAirCbSec = '';
  heatCbPrim = '';
  coolCbPrim = '';
  heatCbSec = '';
  coolCbSec = '';
  baselinePrim = '';
  heatCOPPrim = '';
  coolCOPPrim = '';
  baselineSec = '';
  heatCOPSec = '';
  coolCOPSec = '';
  freshAirPrim = [];
  freshAirSec = [];

  ashraeInf;
  necbInf;
  infCostData;
  infData;
  newcustBaseInf;
  proposedLightCost;
  refLightCost;
  proposedLight;
  refLight;
  dhw;
  dhwChanged;
  dhwCostChange;
  selectedCustBaseHvac;
  selectedCustBaseHvacName;
  selectedCustBaseHvacSec;
  selectedCustBaseHvacSecName;
  distCostPrim = '0';
  hCostPrim = '0';
  cCostPrim = '0';
  distCostSec = '0';
  hCostSec = '0';
  cCostSec = '0';
  hrYLumpsum = '0';
  hrNLumpsum = '0';
  hrLumpsumSec = '0';
  srcCust;
  custDHW;
  opCostData;
  ghgCost;
  opCost;
  carbonCost;
  isLoading: boolean = false;
  humidification:any;
  humCost:any;
  humYCost:any;
  humNCost:any;
  humAvlbl:any;
  currentHideArr: any[];
  custName: any = '';
  actualName: any;
  catCustData: any;
  newAshNecb: string;
  cbEnabled: any;
  necbEnabled: any;
  ashraeEnabled: any;
  baselineDefn: any;
  
  constructor(
    private authService: AuthService,
    private router: Router,
    private http: HttpClient,
    public dialog: MatDialog
  ) {}
  selectedIndexChangeNew(val: number) {
    this.selectedIndexo = val;

    if (this.selectedIndexo == 1) {
      var pv = document.getElementById('heateng').innerText;
      this.authService.changepvValue(pv);

      var effi = document.getElementById('solarEffi').innerText;
      this.authService.changeeffValue(effi);

      var renew = document.getElementById('renewKw').innerText;
      this.authService.changewindValue(renew);
    }
  }

  NewselectedIndexChange(val: number) {
    this.newselectedIndex = val;
  }

  clickMeForwar() {
    this.selectedIndexo++;

  }

  clickMeBack() {
    this.selectedIndexo--;
  }
  clickMeSubForward() {
    this.newselectedIndex++;
  }
  clickMeSubBack() {
    this.newselectedIndex--;
  }

  onValChange(val) {
    if (val == 'true') {
      this.solarYesNOToggle = true;
    } else if (val == 'false') {
      this.solarYesNOToggle = false;
    }

    // alert(this.solarYn)
  }

  getDefVal(ev) {
    this.keycount++;
    if (this.keycount == 1) {
      this.defv = +ev.target.innerText;
    }
    if (this.defv !== ev.target.innerText) {
      ev.target.style.color = 'red';
      this.CostChanged = 'Y';
    }
  }

  getText(ev, min, max) {
   
    if (ev.target.innerText.indexOf('.') !== -1) {
      var number = ev.target.innerText.split('.');
      if (number.length == 2 && number[1].length > 2) {
        alert('only 2 decimals allowed');
        ev.target.innerHTML = this.defv;
      }
    }
    var nrt = ev.target.id;
    var nrtval = nrt.defaultValue;
    if (+ev.target.innerText.indexOf('-') == 0) {
      alert('Negetive values are not allowed');
      // ev.target.innerHTML = "hello"
      ev.target.innerHTML = this.defv;
    }

    if (+ev.target.innerText < min) {
      alert(
        'Please input a number between' +
          '  ' +
          min +
          ' ' +
          'and' +
          ' ' +
          max +
          ' ' +
          'for this field'
      );
      ev.target.innerHTML = this.defv;
    }
    if (isNaN(ev.target.innerText)) {
      alert('Invalid input. Please enter numbers only.');
      ev.target.innerHTML = this.defv;
    }
}

  loadMore() {
   
    if (this.btntxt == 'Load all WINDOW') {
      document.getElementById('windw').style.height = 'auto';
      this.btntxt = 'Load 7 WINDOW';
      // this.heightloadmore = false;
    } else if (this.btntxt == 'Load 7 WINDOW') {
      document.getElementById('windw').style.height = '580px';
      this.btntxt = 'Load all WINDOW';
      // this.heightloadmore = true;
    }
  }

  goHome() {
    this.isLoading = false;
    //this.router.navigate(['chart']);
    if (this.newEmail !== 'demo@ecomatrix.io') {
      this.updateHeatCoolInterCost();
    }
    this.authService.changeheatEff(this.heatEffectCost);
    this.authService.changecoolEff(this.coolEffectCost);
    if (this.isUpdated == true) {
      this.authService.changeisEditable('true');
      this.isLoading = false;
      const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
        position: ({top: "5%"}),
        width: "63vw",
        //height: '250px',
        data: { name: this.name, animal: this.animal },
      });

      this.percent = 0;
      this.time = 60;
    }

    if (this.isUpdated == false) {

         this.isLoading = false;
      const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
        position: ({top: "5%"}),
        width: "63vw",
        //height: '250px',
        data: { name: this.name, animal: this.animal },
      });
    } else {
    this.isLoading = false;
      this.authService.changeIsUpdated('Y');
      this.router.navigate(['mrfd']);
    }
  }

  onWindValChange(val) {
    if (val == 'true') {
      this.solarYnWin = 'Yes';
    } else if (val == 'false') {
      this.solarYnWin = 'No';
    }
  }

  onBlurMethodSolar() {
    this.SolarChanged = 'Y';

    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }

    var initialcost = this.rewval.projLists[0].solar_cost;
    var solarcost = document.getElementById('solarcost').innerHTML;

    if (initialcost != solarcost) {
      //this.CostChanged ="N";

      this.isLoading = true;
      const bodyparm = new HttpParams()
        .set('user_id', this.condId)
        .set('proj_id', this.newProjId.toString())
        .set('solar_cost', solarcost);
      this.http
        .post(this.rootDomainUrl + 'adeos/api/update_solar_cost.php', bodyparm)
        .subscribe((data) => {
            this.isLoading = false;
        });
    }
  }

  onBlurMethodWind() {
    this.WindChanged = 'Y';
    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }

    var wincost = document.getElementById('windcost').innerHTML;
    var initialcost = this.rewval.projLists[0].wind_cost;

    if (initialcost != wincost) {
      //this.CostChanged ="N";

      this.isLoading = true;
      const bodyparm = new HttpParams()
        .set('user_id', this.condId)
        .set('proj_id', this.newProjId.toString())
        .set('wind_cost', wincost);
      this.http
        .post(this.rootDomainUrl + 'adeos/api/update_solar_cost.php', bodyparm)
        .subscribe((data) => {
            this.isLoading = false;
        });
    }
  }
  onBlurMethodDhw(option1) {
    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }

    var wincost = document.getElementById('dhwcost-' + option1).innerHTML;

    if (this.dhwCostChange != wincost) {
      this.CostChanged = 'Y';

      this.isLoading = true;
      const bodyparm = new HttpParams()
        .set('user_id', this.condId)
        .set('proj_id', this.newProjId.toString())
        .set('dhw_cost', wincost)
        .set('option1', option1);
      this.http
        .post(this.rootDomainUrl + 'adeos/api/update_dhw_cost.php', bodyparm)
        .subscribe((data) => {
            this.isLoading = false;
        });
    }
  }
  getFirstLumpsum(id): void {
    this.lumpsum = document.getElementById('fa-' + id).innerHTML;
  }

  onBlurMethodLumpsum(id, hr, type): void {
    var hvacct = id;

    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }
    var lumpsumNew;
    if (type == 1) {
      if (hr == 'Y') lumpsumNew = document.getElementById('fa-' + id).innerHTML;
      else lumpsumNew = document.getElementById('fa2-' + id).innerHTML;
    } else {
      lumpsumNew = document.getElementById('lumpsumSec-' + id).innerHTML;
    }

    if (lumpsumNew !== this.lumpsum) {
      //this.CostChanged ="N";

      this.isLoading = true;
      const bodyparm = new HttpParams()
        .set('user_id', this.condId)
        .set('proj_id', this.newProjId.toString())
        .set('cost', lumpsumNew)
        .set('type', type)
        .set('heat_rec', hr)
        .set('baseline', '"' + id + '"');
      this.http
        .post(
          this.rootDomainUrl + 'adeos/api/update_freshair_cost.php',
          bodyparm
        )
        .subscribe((data) => {
            this.isLoading = false;
        });
    }
  }
  getSecondLumpsum(id): void {
    this.lumpsum = document.getElementById('fa2-' + id).innerHTML;
  }
  getFirstLumpsumSec(id): void {
    this.lumpsum = document.getElementById('lumpsumSec-' + id).innerHTML;

  }

  onBlurMethodLumpsumSec(id): void {
    var hvacct = id;

    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }

    var lumpsumNew = document.getElementById('lumpsumSec_' + id).innerHTML;
    var base = document.getElementById('baseline_' + id).innerHTML;

    if (lumpsumNew !== this.lumpsum) {
      //this.CostChanged ="N";

      this.isLoading = true;
      const bodyparm = new HttpParams()
        .set('user_id', this.condId)
        .set('proj_id', this.newProjId.toString())
        .set('cost', lumpsumNew)
        .set('baseline', base.trim());
      this.http
        .post(
          this.rootDomainUrl + 'adeos/api/update_freshair_cost.php',
          bodyparm
        )
        .subscribe((data) => {
            this.isLoading = false;
        });
    }
  }

  onBlurMethodHeat() {
    this.HeatEffChanged = 'Y';
    this.CostChanged = 'N';
  }

  updateHeatCoolInterCost() {
    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }
    if (this.toggleStatusNewWind == 'false') {
      this.WindEnabled = 'N';
    }
    if (this.toggleStatusNewWind == 'true') {
      this.WindEnabled = 'Y';
    }
    if (this.toggleStatusNew == 'false') {
      this.SolarEnabled = 'N';
    }
    if (this.toggleStatusNew == 'true') {
      this.SolarEnabled = 'Y';
    }
    if (this.toggleStatusNewDhw == 'false') {
      this.isDhwEnabled = 'N';
    }
    if (this.toggleStatusNewDhw == 'true') {
      this.isDhwEnabled = 'Y';
    }

    this.isLoading = true;
    const param = new HttpParams()
      .set('loggedin_user_id', this.newUserId.toString())
      .set('user_id', this.condId)
      .set('proj_id', this.newProjId.toString())
      .set('isSolarChanged', 'N')
      .set('isWindChanged', 'N')
      .set('isFreshAirChanged', 'N')
      .set('isHeatEffChanged', 'N')
      .set('isSolarEnabled', this.SolarEnabled)
      .set('isWindEnabled', this.WindEnabled)
      .set('windToggleChanged', 'N')
      .set('solarToggleChanged', 'N')
      .set('isDhwEnabled', 'Y')
      .set('isDhwChanged', 'N')
      .set('isCostChanged', this.CostChanged);
    if (this.CostChanged == 'Y') {
      this.isUpdated = true;
      this.selectedIndex = 0;
      return this.http
        .post(this.rootDomainUrl + 'adeos/api/update_heat_cool.php', param)
        .pipe(map((res) => res))
        .subscribe((data) => {
            this.isLoading = false;
        });
    }
  }
  // wall values function

  getIdfirst(ev, id): void {
    // this.orgidfirst = document.getElementById("btnnew-"+id).innerHTML;
    this.orgidfirst = ev.target.innerText;
    var boilerCOP = document.getElementById('btn-' + id).innerHTML;

    if (boilerCOP.trim() == this.buildEnv.projLists[0].wall_r_value_ip) {
      this.newboilerCOP = this.w1;
    } else if (boilerCOP.trim() == this.buildEnv.projLists[1].wall_r_value_ip) {
      this.newboilerCOP = this.w2;
    } else if (boilerCOP.trim() == this.buildEnv.projLists[2].wall_r_value_ip) {
      this.newboilerCOP = this.w3;
    } else if (boilerCOP.trim() == this.buildEnv.projLists[3].wall_r_value_ip) {
      this.newboilerCOP = this.w4;
    } else if (boilerCOP.trim() == this.buildEnv.projLists[4].wall_r_value_ip) {
      this.newboilerCOP = this.w5;
    } else if (boilerCOP.trim() == this.buildEnv.projLists[5].wall_r_value_ip) {
      this.newboilerCOP = this.w6;
    } else if (boilerCOP.trim() == this.buildEnv.projLists[6].wall_r_value_ip) {
      this.newboilerCOP = this.w7;
    }

}

  getHvac(id): void {
    // alert(document.getElementById("btnnew-"+id).innerHTML)
    var hvacct = id;

    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }
    var boilerCOP = document.getElementById('btn-' + id).innerHTML;
    var chillerCOP = document.getElementById('btnnew-' + id).innerText?.trim()||0;

    if (chillerCOP != this.orgidfirst) {
      //this.CostChanged ="N";
      this.isLoading = true;
      const bodyparm = new HttpParams()
        .set('user_id', this.condId)
        .set('proj_id', this.newProjId.toString())
        .set('wall', '"' + id + '"')
        .set('wallCost', chillerCOP);
      this.http
        .post(
          this.rootDomainUrl + 'adeos/api/update_buildingenv_cost.php',
          bodyparm
        )
        .subscribe((data) => {

            this.isLoading = false;
        });
    }
  }

  // wall values function end

  // roof values function start

  getIdfirstRoof(ev, id): void {
    this.orgidsecond = ev.target.innerText;
    var boilerCOP = document.getElementById('btnroof-' + id).innerHTML;

    if (boilerCOP.trim() == this.buildEnv.projLists[0].roof_r_value_ip) {
      this.newboilerCOP = this.r1;
    } else if (boilerCOP.trim() == this.buildEnv.projLists[1].roof_r_value_ip) {
      this.newboilerCOP = this.r2;
    } else if (boilerCOP.trim() == this.buildEnv.projLists[2].roof_r_value_ip) {
      this.newboilerCOP = this.r3;
    } else if (boilerCOP.trim() == this.buildEnv.projLists[3].roof_r_value_ip) {
      this.newboilerCOP = this.r4;
    } else if (boilerCOP.trim() == this.buildEnv.projLists[4].roof_r_value_ip) {
      this.newboilerCOP = this.r5;
    }
  }

  getHvacRoof(id): void {
    // alert(document.getElementById("btnnew-"+id).innerHTML)
    var hvacct = id;

    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }

    var boilerCOP = document.getElementById('btnroof-' + id).innerHTML;
    var chillerCOP = document.getElementById('btnroofnew-' + id).innerText?.trim()||0;

    if (chillerCOP != this.orgidsecond) {

        this.isLoading = true;
      const bodyparm = new HttpParams()
        .set('user_id', this.condId)
        .set('proj_id', this.newProjId.toString())
        .set('roof', '"' + id + '"')
        .set('roofCost', chillerCOP);
      this.http
        .post(
          this.rootDomainUrl + 'adeos/api/update_buildingenv_cost.php',
          bodyparm
        )
        .subscribe((data) => {

      this.isLoading = false;
        });
    }
  }

  // roof values function end

  // floor values function start

  getIdfirstFloor(ev, id): void {
    // this.orgidthird = document.getElementById("btnfloornew-"+id).innerHTML;
    this.orgidthird = ev.target.innerText;

    var boilerCOP = document.getElementById('btnfloor-' + id).innerHTML;

    

    if (boilerCOP.trim() == this.buildEnv.projLists[0].floor_r_value_ip) {
      this.newboilerCOP = this.f1;
    } else if (
      boilerCOP.trim() == this.buildEnv.projLists[1].floor_r_value_ip
    ) {
      this.newboilerCOP = this.f2;
    } else if (
      boilerCOP.trim() == this.buildEnv.projLists[2].floor_r_value_ip
    ) {
      this.newboilerCOP = this.f3;
    }

  }
  getDhwOption(id): void {
    this.dhwCostChange = document.getElementById('dhwcost-' + id).innerHTML;
  }

  getHvacFloor(id): void {
    // alert(document.getElementById("btnnew-"+id).innerHTML)
    var hvacct = id;

    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }

    var boilerCOP = document.getElementById('btnfloor-' + id).innerHTML;
    var chillerCOP = document.getElementById('btnfloornew-' + id).innerText?.trim()||0;


    if (chillerCOP !== this.orgidthird) {
      // this.CostChanged ="N";

      this.isLoading = true;
      const bodyparm = new HttpParams()
        .set('user_id', this.condId)
        .set('proj_id', this.newProjId.toString())
        .set('floor', '"' + id + '"')
        .set('floorCost', chillerCOP);
      this.http
        .post(
          this.rootDomainUrl + 'adeos/api/update_buildingenv_cost.php',
          bodyparm
        )
        .subscribe((data) => {

      this.isLoading = false;
        });
    }
  }

  // floor values function end

  // windows values function start

  getIdfirstWindows(id): void {
    this.orgidfourth = document.getElementById('btnnew-' + id).innerText?.trim()||0;

    var boilerCOP = document.getElementById('btn-' + id).innerHTML;
    
  }

  getHvacWindows(id): void {
    // alert(document.getElementById("btnnew-"+id).innerHTML)
    var hvacct = id;

    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }

    var boilerCOP = document.getElementById('btn-' + id).innerHTML;
    var chillerCOP = document.getElementById('btnnew-' + id).innerHTML;


    if (chillerCOP !== this.orgidfourth) {
      // this.CostChanged ="N";

      this.isLoading = true;
      const bodyparm = new HttpParams()
        .set('user_id', this.condId)
        .set('proj_id', this.newProjId.toString())
        .set('win', '"' + id + '"')
        .set('winCost', chillerCOP);
      this.http
        .post(
          this.rootDomainUrl + 'adeos/api/update_buildingenv_cost.php',
          bodyparm
        )
        .subscribe((data) => {
            this.isLoading = false;
        });
    }
  }

  getIdfirstShading(id): void {
    this.orgidfifth = document.getElementById('btnnew-' + id).innerText?.trim()||0;

    var boilerCOP = document.getElementById('btn-' + id).innerHTML;
  
  }

  getHvacShading(id): void {
    
    // alert(document.getElementById("btnnew-"+id).innerHTML)
    var hvacct = id;
    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }

    var boilerCOP = document.getElementById('btn-' + id).innerHTML;
    var chillerCOP = document.getElementById('btnnew-' + id).innerHTML;

    
    if (chillerCOP !== this.orgidfifth) {
      // this.CostChanged ="N";

      this.isLoading = true;
      const bodyparm = new HttpParams()
        .set('user_id', this.condId)
        .set('proj_id', this.newProjId.toString())
        .set('shading', '"' + id + '"')
        .set('shadingCost', chillerCOP);
      this.http
        .post(
          this.rootDomainUrl + 'adeos/api/update_buildingenv_cost.php',
          bodyparm
        )
        .subscribe((data) => {
            this.isLoading = false;
        });
    }
  }

  // shading end values

  // Lighting start values

  getIdfirstLighting(id): void {
    this.orgidsix = document.getElementById('btnnew-' + id).innerText?.trim()||0;

   
  }

  getHvacLighting(id): void {
   
    // alert(document.getElementById("btnnew-"+id).innerHTML)
    var hvacct = id;

    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }

  
    var chillerCOP = document.getElementById('btnnew-' + id).innerText?.trim()||0;

   
    if (chillerCOP !== this.orgidsix) {
      // this.CostChanged ="N";

      this.isLoading = true;
      const bodyparm = new HttpParams()
        .set('user_id', this.condId)
        .set('proj_id', this.newProjId.toString())
        .set('lighting', '"' + id + '"')
        .set('lightingCost', chillerCOP);
      this.http
        .post(
          this.rootDomainUrl + 'adeos/api/update_lightingdls_cost.php',
          bodyparm
        )
        .subscribe((data) => {
            this.isLoading = false;
        });
    }
  }
  getIdfirstInf(id): void {
    this.orgIdInf = document.getElementById('inf-' + id).innerText?.trim()||0;
  }
  getHvacInf(id): void {
    var hvacct = id;

    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }

    var chillerCOP = document.getElementById('infnew-' + id).innerHTML;

    if (chillerCOP !== this.orgIdInf) {
      // this.CostChanged ="N";

      this.isLoading = true;
      const bodyparm = new HttpParams()
        .set('user_id', this.condId)
        .set('proj_id', this.newProjId.toString())
        .set('inf', '"' + id + '"')
        .set('infCost', chillerCOP);
      this.http
        .post(this.rootDomainUrl + 'adeos/api/update_inf_cost.php', bodyparm)
        .subscribe((data) => {
            this.isLoading = false;
        });
    }
  }
  // Lighting end values

  // DLS start values

  getIdfirstDls(id): void {
    this.orgidseven = document.getElementById('btnnew-' + id).innerText?.trim()||0;

    var boilerCOP = document.getElementById('btn-' + id).innerHTML;

    if (boilerCOP == 'YES') {
      this.newboilerCOP = 'DLON';
    }
    if (boilerCOP == 'NO') {
      this.newboilerCOP = 'DLOFF';
    }

    
  }

  getHvacDls(id): void {
    if (id == 'YES') {
      this.newboilerCOP = 'DLON';
    }
    if (id == 'NO') {
      this.newboilerCOP = 'DLOFF';
    }
    // alert(document.getElementById("btnnew-"+id).innerHTML)
    var hvacct = id;

    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }

    var boilerCOP = document.getElementById('btn-' + id).innerHTML;
    var chillerCOP = document.getElementById('btnnew-' + id).innerText?.trim()||0;

   

    if (chillerCOP !== this.orgidseven) {
      //this.CostChanged ="N";

      this.isLoading = true;
      const bodyparm = new HttpParams()
        .set('user_id', this.condId)
        .set('proj_id', this.newProjId.toString())
        .set('dls', '"' + this.newboilerCOP + '"')
        .set('dlsCost', chillerCOP);
      this.http
        .post(
          this.rootDomainUrl + 'adeos/api/update_lightingdls_cost.php',
          bodyparm
        )
        .subscribe((data) => {
            this.isLoading = false;
        });
    }
  }

  // DLS end values

  // hvac start values

  getIdfirstHvac(id): void {
    this.orgideight = document.getElementById('btnnew-' + id).innerText?.trim()||0;

    var boilerCOP = document.getElementById('btn-' + id).innerHTML;

  }

  getHvacHvac(id, type): void {
    
    // alert(document.getElementById("btnnew-"+id).innerHTML)
    var hvacct = id;

    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }

    var chillerCOP;
    if (type == 1)
      chillerCOP = document.getElementById('btnnew-' + id).innerText?.trim()||0;
    else
      chillerCOP = document.getElementById('btnnewtwoHvacSec-' + id).innerHTML;

    

    if (chillerCOP !== this.orgideight) {
        this.isLoading = true;
      //this.CostChanged ="N";
      const bodyparm = new HttpParams()
        .set('user_id', this.condId)
        .set('proj_id', this.newProjId.toString())
        .set('hvac_system_id', '"' + id + '"')
        .set('distributionCost', chillerCOP)
        .set('hvac_type', type);
      this.http
        .post(this.rootDomainUrl + 'adeos/api/update_hvac_cost.php', bodyparm)
        .subscribe((data) => {
            this.isLoading = false;
        });
    }
  }

  // hvac end values

  // hvactwo start values

  getIdfirstDist(id): void {
    this.orgidnine = document.getElementById('btnnew-' + id).innerHTML;
   
  }

  getIdfirstHeat(id): void {
    this.orgidnine = document.getElementById('btnnewtwo-' + id).innerHTML;
  }

  getHvacHvactwo(id, type): void {
    
    // alert(document.getElementById("btnnew-"+id).innerHTML)
    var hvacct = id;

    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }

    var chillerCOP;
    if (type == 1)
      chillerCOP = document.getElementById('btnnewtwo-' + id).innerHTML;
    else chillerCOP = document.getElementById('btnnewHvacHeat-' + id).innerHTML;
   

    if (chillerCOP !== this.orgidnine) {
      // this.CostChanged ="N";

      this.isLoading = true;
      const bodyparm = new HttpParams()
        .set('user_id', this.condId)
        .set('proj_id', this.newProjId.toString())
        .set('hvac_system_id', '"' + id + '"')
        .set('heatingCost', chillerCOP)
        .set('hvac_type', type);
      this.http
        .post(this.rootDomainUrl + 'adeos/api/update_hvac_cost.php', bodyparm)
        .subscribe((data) => {
            this.isLoading = false;
        });
    }
  }
  getIdfirstSecHvac(id): void {
    this.orgidnine = document.getElementById(
      'btnnewtwoHvacSec-' + id
    ).innerHTML;
  }
  getIdfirstSecHvacHeat(id): void {
    this.orgidnine = document.getElementById('btnnewHvacHeat-' + id).innerHTML;

    
  }
  getIdfirstHvacCool(id): void {
    this.orgidnine = document.getElementById('btnnewHvacCool-' + id).innerHTML;

    
  }

  getHvacHvactwoSecHvac(id): void {
    
    var hvacct = id;

    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }

    //var boilerCOP = document.getElementById("btn-"+id).innerHTML;
    var chillerCOP = document.getElementById('btnnewtwo-' + id).innerHTML;

    

    if (chillerCOP !== this.orgidnine) {
      // this.CostChanged ="N";

      this.isLoading = true;
      const bodyparm = new HttpParams()
        .set('user_id', this.condId)
        .set('proj_id', this.newProjId.toString())
        .set('hvac_system_id', '"' + id + '"')
        .set('distributionCost', chillerCOP)
        .set('hvac_type', '2');
      this.http
        .post(this.rootDomainUrl + 'adeos/api/update_hvac_cost.php', bodyparm)
        .subscribe((data) => {
            this.isLoading = false;
        });
    }
  }

  // hvactwo end values

  // hvacthree start values

  getIdfirstHvacthree(id): void {
    this.orgidten = document.getElementById('btnnewthree-' + id).innerHTML;

    var boilerCOP = document.getElementById('btn-' + id).innerHTML;
    
  }

  getHvacHvacthree(id, type): void {
    
    // alert(document.getElementById("btnnew-"+id).innerHTML)
    var hvacct = id;

    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }

    
    var chillerCOP;
    if (type == 1)
      chillerCOP = document.getElementById('btnnewthree-' + id).innerHTML;
    else chillerCOP = document.getElementById('btnnewHvacCool-' + id).innerHTML;

    

    if (chillerCOP !== this.orgidten) {
      // this.CostChanged ="N";

      this.isLoading = true;
      const bodyparm = new HttpParams()
        .set('user_id', this.condId)
        .set('proj_id', this.newProjId.toString())
        .set('hvac_system_id', '"' + id + '"')
        .set('coolingCost', chillerCOP)
        .set('hvac_type', type);
      this.http
        .post(this.rootDomainUrl + 'adeos/api/update_hvac_cost.php', bodyparm)
        .subscribe((data) => {
            this.isLoading = false;
        });
    }
  }
  getIdfirstHvacSec(id): void {
    this.orgideight = document.getElementById('btnnewSec-' + id).innerHTML;

    var boilerCOP = document.getElementById('btnSec-' + id).innerHTML;

    
  }

  getHvacHvacSec(id): void {
    
    // alert(document.getElementById("btnnew-"+id).innerHTML)
    var hvacct = id;

    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }

    
    //var boilerCOP = document.getElementById("btn-"+id).innerHTML;
    var chillerCOP = document.getElementById('btnnewSec-' + id).innerHTML;

   

    if (chillerCOP !== this.orgideight) {
      //this.CostChanged ="N";
      
      this.isLoading = true;
      const bodyparm = new HttpParams()
        .set('user_id', this.condId)
        .set('proj_id', this.newProjId.toString())
        .set('hvac_system_id', '"' + id + '"')
        .set('distributionCost', chillerCOP)
        .set('hvac_type', '1');
      this.http
        .post(this.rootDomainUrl + 'adeos/api/update_hvac_cost.php', bodyparm)
        .subscribe((data) => {
          
            this.isLoading = false;
        });
    }
  }
  getIdfirstHvactwoSec(id): void {
    this.orgideight = document.getElementById('btnnewtwoSec-' + id).innerHTML;

    var boilerCOP = document.getElementById('btnSec-' + id).innerHTML;
    
  }

  getHvacHvactwoSec(id): void {
    
    // alert(document.getElementById("btnnew-"+id).innerHTML)
    var hvacct = id;

    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }

    
    //var boilerCOP = document.getElementById("btn-"+id).innerHTML;
    var chillerCOP = document.getElementById('btnnewtwoSec-' + id).innerHTML;

    

    if (chillerCOP !== this.orgideight) {
      //this.CostChanged ="N";
      
      this.isLoading = true;
      const bodyparm = new HttpParams()
        .set('user_id', this.condId)
        .set('proj_id', this.newProjId.toString())
        .set('hvac_system_id', '"' + id + '"')
        .set('heatingCost', chillerCOP)
        .set('hvac_type', '1');
      this.http
        .post(this.rootDomainUrl + 'adeos/api/update_hvac_cost.php', bodyparm)
        .subscribe((data) => {
            this.isLoading = false;
        });
    }
  }

  getIdfirstHvacthreeSec(id): void {
    this.orgideight = document.getElementById('btnnewthreeSec-' + id).innerHTML;

    var boilerCOP = document.getElementById('btnSec-' + id).innerHTML;
    
  }

  getHvacHvacthreeSec(id): void {
    
    // alert(document.getElementById("btnnew-"+id).innerHTML)
    var hvacct = id;

    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }

    
    //var boilerCOP = document.getElementById("btn-"+id).innerHTML;
    var chillerCOP = document.getElementById('btnnewthreeSec-' + id).innerHTML;

    

    if (chillerCOP !== this.orgideight) {
      //this.CostChanged ="N";
      
      this.isLoading = true;
      const bodyparm = new HttpParams()
        .set('user_id', this.condId)
        .set('proj_id', this.newProjId.toString())
        .set('hvac_system_id', '"' + id + '"')
        .set('coolingCost', chillerCOP)
        .set('hvac_type', '1');
      this.http
        .post(this.rootDomainUrl + 'adeos/api/update_hvac_cost.php', bodyparm)
        .subscribe((data) => {
            this.isLoading = false;
          
        });
    }
  }
  // hvacthree end values
   getHumValue(id): void {
    this.humYCost = document.getElementById('btnHumY-' + id).innerHTML;
  }

  getHumidification(id): void {
    
    // alert(document.getElementById("btnnew-"+id).innerHTML)
    var hvacct = id;

    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }

    var ervycost;

    ervycost = document.getElementById('btnHumY-' + id).innerHTML;

    

    if (ervycost !== this.humYCost) {
        this.isLoading = true;
      //this.CostChanged ="N";
      const bodyparm = new HttpParams()
        .set('user_id', this.condId)
        .set('proj_id', this.newProjId.toString())
        .set('hvac_system_id', '"' + id + '"')
        .set('ervycost', ervycost)
		.set('ervncost', "")
        .set('isErvyChanged', 'Y')
		.set('isErvnChanged', 'N');
		console.log('bodyParam '+bodyparm);
      this.http
        .post(this.rootDomainUrl + 'adeos/api/update_humidification_cost.php', bodyparm)
        .subscribe((data) => {
            this.isLoading = false;
        });
    }
  }
 getHumValueN(id): void {
    this.humNCost = document.getElementById('btnHumN-' + id).innerHTML;
  }

  getHumidificationN(id): void {
    
    // alert(document.getElementById("btnnew-"+id).innerHTML)
    var hvacct = id;

    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }

    var ervncost;

    ervncost = document.getElementById('btnHumN-' + id).innerHTML;

    

    if (ervncost !== this.humNCost) {
        this.isLoading = true;
      //this.CostChanged ="N";
      const bodyparm = new HttpParams()
        .set('user_id', this.condId)
        .set('proj_id', this.newProjId.toString())
        .set('hvac_system_id', '"' + id + '"')
        .set('ervycost', "")
		.set('ervncost', ervncost)
        .set('isErvyChanged', 'N')
		.set('isErvnChanged', 'Y');
		console.log('bodyParam '+bodyparm);
      this.http
        .post(this.rootDomainUrl + 'adeos/api/update_humidification_cost.php', bodyparm)
        .subscribe((data) => {
            this.isLoading = false;
        });
    }
  }
  ngOnInit() {
   

    this.authService.checkUpdateStatus().subscribe((data) => {
      
      this.recCount = data;
      this.percent = this.recCount.percentage;
      this.time = this.recCount.time;
      for (var i = 0; i < this.recCount.num_records.length; i++) {
        var recCount = this.recCount.num_records[i].recCount;
        if (recCount > 0 && recCount < 5184) {
          this.isUpdated = true;
          
        }
      }
    });

    this.authService.currentToggleStatusWind.subscribe(
      (toggleStatusNewWind) => (this.toggleStatusNewWind = toggleStatusNewWind)
    );
    
    this.authService.currentToggleStatusDhw.subscribe(
      (toggleStatusNewDhw) => (this.toggleStatusNewDhw = toggleStatusNewDhw)
    );
    this.authService.currentToggleStatus.subscribe(
      (toggleStatusNew) => (this.toggleStatusNew = toggleStatusNew)
    );

    this.contentEditableRen = false;
    this.authService.currentheatEff.subscribe(
      (newheatEff) => (this.newheatEff = newheatEff)
    );
    this.authService.currentcoolEff.subscribe(
      (newcoolEff) => (this.newcoolEff = newcoolEff)
    );

    this.authService.currentwindValue.subscribe(
      (newwindValue) => (this.newwindValue = newwindValue)
    );
    this.authService.currenteffValue.subscribe(
      (neweffValue) => (this.neweffValue = neweffValue)
    );
    this.authService.currentpvValue.subscribe(
      (newpvValue) => (this.newpvValue = newpvValue)
    );

    this.authService.currentUserId.subscribe(
      (newUserId) => (this.newUserId = newUserId)
    );
    this.authService.currenteventId.subscribe(
      (newEventId) => (this.newEventId = newEventId)
    );
    this.authService.currentprojId.subscribe(
      (newProjId) => (this.newProjId = newProjId)
    );
    this.authService.currentClientEmail.subscribe(
      (newEmail) => (this.newEmail = newEmail)
    );

    this.rootDomainUrl = this.authService.rootDomainUrl;
    this.CostChanged = 'N';
    this.HeatEffChanged = 'N';
    this.WindChanged = 'N';
    this.SolarChanged = 'N';
    this.contentEditableWin = false;
    if (this.newEmail == 'demo@ecomatrix.io') {
      this.contedit = false;
    } else {
      this.contedit = true;
    }
    this.authService.currentMessage.subscribe((message) => {
      console.log(message);
      this.message = (message); 
    });
    this.authService.currenthideAxisArr.subscribe(
     
      (currentHideArr) => {
        console.log(currentHideArr);
        this.currentHideArr = currentHideArr;
      });
    this.authService.currentToggleEditable.subscribe(
      (newToggleEditable) => (this.newToggleEditable = newToggleEditable)
    );
    if (this.newEmail == 'demo@ecomatrix.io') {
      this.authService.newchartBeCost('No');
    this.message = 'wall="R17","R18.5","R21.5","R26.4"&roof="R35","R45","R50"&floor="CurtainWalls-USI-1.6","CurtainWalls-USI-1.2"&window="USI-1.9,g-0.25"|"USI-1.9,g-0.2"|"USI-1.25,g-0.25"|"USI-1.25,g-0.2"|"USI-1.09,g-0.25"|"USI-1.09,g-0.2"&inf="0.44-l/s/m2(fac)","0.25-l/s/m2(fac)","0.1-l/s/m2(fac)"&shading="NO","YES"&wwr="0.433","0.301","0.151"&dl="DLOFF","DLON"&hvac="Op0 - Standalone w/o HR chiller","Op1 - Standalone with HR Chiller","Op2 - Central HSC Plant with HR Chiller","Op3 - Central HSC Plant with HP Chiller"&heatRecovery="S:0.83 L:0.7"';
    }

    

    this.authService.currentcustBaseDaylight.subscribe(
      (newcustDaylight) => (this.newcustDaylight = newcustDaylight)
    );

    this.authService.currentcustBaseWwr.subscribe(
      (newcustBaseWwr) => {
        this.newcustBaseWwr = newcustBaseWwr;

        this.newcustBaseWwr = (this.newcustBaseWwr.replace('%', '') / 100).toFixed(3);

      });

    this.authService.currentcustBaseLighting.subscribe(
      (newcustBaseLighting) => (this.newcustBaseLighting = newcustBaseLighting)
    );

    this.authService.currentcustBaseShading.subscribe(
      (newcustBaseShading) => (this.newcustBaseShading = newcustBaseShading)
    );

    this.authService.currentcustBaseWindow.subscribe(
      (newcustBaseWindow) => (this.newcustBaseWindow = newcustBaseWindow)
    );

    this.authService.currentcustBaseFloor.subscribe(
      (newcustBaseFloor) => (this.newcustBaseFloor = newcustBaseFloor)
    );

    this.authService.currentcustBase.subscribe(
      (newcustBase) => (this.newcustBase = newcustBase)
    );

    this.authService.currentcustBaseInf.subscribe(
      (newcustBaseInf) => (this.newcustBaseInf = newcustBaseInf)
    );

    this.authService.currentcustBaseRoof.subscribe(
      (newcustBaseRoof) => (this.newcustBaseRoof = newcustBaseRoof)
    );
    this.authService.currentcustBaseHvac.subscribe(
      (newcustHvac) => (this.newcustBaseHvac = newcustHvac)
    );
    this.authService.currentcustBaseHtRec.subscribe(
      (newcustHtRec) => (this.newcustBaseHeatRec = newcustHtRec)
    );
    this.authService.currentcustBaseDaylight.subscribe(
      (newcustDaylight) => (this.newcustBaseDl = newcustDaylight)
    );
    this.authService.currentCustName.subscribe(
      (custName: any) => (this.custName = custName)
    );
    this.authService.currentActualName.subscribe(
      (actName: any) => (this.actualName = actName)
    );
    this.heatEffectCost = this.newheatEff;
    this.coolEffectCost = this.newcoolEff;
    

    if (this.newEmail == 'demo@ecomatrix.io') {

      this.authService.baselineDefnData().subscribe((data) => { 
        this.baselineDefn = data.projLists;
        
        this.ashraeEnabled = this.baselineDefn[1].ashrae;
        this.necbEnabled = this.baselineDefn[1].necb;
        this.cbEnabled = this.baselineDefn[1].cb;
        if(this.ashraeEnabled == "Y") {
          this.newAshNecb = "Ashare";
        } else if(this.necbEnabled == "Y") {
          this.newAshNecb = "Necb";
        } else {
          this.newAshNecb = "noash";
        }
      })

       this.authService.categoryCustomizationData().subscribe((data) => {
      this.catCustData = data;
      if (this.catCustData.projLists) {
        this.actualName = this.catCustData.projLists[0].actual_name;
        this.custName = this.catCustData.projLists[0].customized_name;
        if(this.custName.length > 0)
        console.log(this.actualName);
        console.log(this.custName);
        this.authService.changeActualName(this.actualName);
		    this.authService.changeCustName(this.custName);
      }
    });
    

    }


    //alert(this.newpvValue)
    //this.change(e, type)
    this.authService.modelValues().subscribe((data) => {
      this.modval = data;
      
      /*  if(this.modval.success == 3) {
          alert("No existing data found. Please upload a file")
          this.router.navigate(['/logedin']);
          
        } */
      
    });
   
    this.authService.renewablesCostData().subscribe((data) => {
      this.rewval = data;
      
      if (this.rewval.projLists > 0) {
        this.solarYesNO = this.rewval.projLists[0].solar_y_n;
      }
      if (this.solarYesNO == 'Yes') {
        this.solarYesNOToggle = true;
      } else if (this.solarYesNO == 'No') {
        this.solarYesNOToggle = false;
      }
      
    });
    if (this.newEmail == 'demo@ecomatrix.io') {
      this.toggleStatusNew = false;
    }
    this.authService.buildingEnvData().subscribe((data) => {
      this.BuildEnvCost = data;
      //this.BuildEnvCost.projLists.replace(/\s/g, "");

       if(this.newEmail == 'demo@ecomatrix.io'){ 
		this.newcustBase = this.BuildEnvCost.projLists[6].custom_baseline.WALL;
		this.newcustBaseRoof =
          this.BuildEnvCost.projLists[6].custom_baseline.ROOF;
		this.newcustBaseFloor =
          this.BuildEnvCost.projLists[6].custom_baseline.FLOOR;
		this.newcustBaseWindow =
          this.BuildEnvCost.projLists[6].custom_baseline.WINDOW;
		this.newcustBaseShading =
          this.BuildEnvCost.projLists[6].custom_baseline.SHADING;
		this.newcustBaseWwr =
          (this.BuildEnvCost.projLists[6].custom_baseline.WWR1 * 100).toFixed(1) + '%';
   }

      //  wall ashrae and necb values
      this.ashraewall = this.BuildEnvCost.projLists[6].ashrae.WALL;
      this.necbwall = this.BuildEnvCost.projLists[6].necb.WALL;

      this.ashraeroof = this.BuildEnvCost.projLists[6].ashrae.ROOF;
      this.necbroof = this.BuildEnvCost.projLists[6].necb.ROOF;

      this.ashraefloor = this.BuildEnvCost.projLists[6].ashrae.FLOOR;
      this.necbfloor = this.BuildEnvCost.projLists[6].necb.FLOOR;

      for (var i = 0; i < this.BuildEnvCost.projLists.length; i++) {
        this.BuildEnvCost.projLists[i].wwr_percentage =
          this.BuildEnvCost.projLists[i].wwr_percentage * 100 + '%';
        if (this.BuildEnvCost.projLists[i].wall == this.ashraewall) {
         
          this.BuildEnvCost.projLists[6].ashrae.WALL =
            this.BuildEnvCost.projLists[i].wall_r_value_ip;
        }
        if (this.BuildEnvCost.projLists[i].wall == this.necbwall) {
          
          this.BuildEnvCost.projLists[6].necb.WALL =
            this.BuildEnvCost.projLists[i].wall_r_value_ip;
        }
        if (this.BuildEnvCost.projLists[i].roof == this.ashraeroof) {
          this.BuildEnvCost.projLists[6].ashrae.ROOF =
            this.BuildEnvCost.projLists[i].roof_r_value_ip;
        }
        if (this.BuildEnvCost.projLists[i].roof == this.necbroof) {
          this.BuildEnvCost.projLists[6].necb.ROOF =
            this.BuildEnvCost.projLists[i].roof_r_value_ip;
        }

        if (this.BuildEnvCost.projLists[i].floor == this.ashraefloor) {
          this.BuildEnvCost.projLists[6].ashrae.FLOOR =
            this.BuildEnvCost.projLists[i].floor_r_value_ip;
        }

        if (this.BuildEnvCost.projLists[i].floor == this.necbfloor) {
          this.BuildEnvCost.projLists[6].necb.FLOOR =
            this.BuildEnvCost.projLists[i].floor_r_value_ip;
        }
      }
      //  window ashrae and necb values
      this.disbwallW = this.BuildEnvCost.projLists[6].ashrae.WINDOW;
      this.disbwallNW = this.BuildEnvCost.projLists[6].necb.WINDOW;

      //  shading ashrae and necb values

      this.disbwallS = this.BuildEnvCost.projLists[6].ashrae.SHADING;

      this.disbwall = this.BuildEnvCost.projLists[6].ashrae.WALL;
      this.disbwallN = this.BuildEnvCost.projLists[6].necb.WALL;

      this.disbwallR = this.BuildEnvCost.projLists[6].ashrae.ROOF;
      this.disbwallNR = this.BuildEnvCost.projLists[6].necb.ROOF;

      this.disbwallF = this.BuildEnvCost.projLists[6].ashrae.FLOOR;
      this.disbwallNF = this.BuildEnvCost.projLists[6].necb.FLOOR;

     
    });

    this.authService.buildingEnvCostData().subscribe((data) => {
      this.buildEnv = data;
      //this.buildEnv.projLists.replace(/\s/g, "");
      

      for (var i = 0; i < this.buildEnv.projLists.length; i++) {
       

        if (i == 0) {
          this.w1 = this.buildEnv.projLists[i].wall;
          this.r1 = this.buildEnv.projLists[i].roof;
          this.f1 = this.buildEnv.projLists[i].floor;
        } else if (i == 1) {
          this.w2 = this.buildEnv.projLists[i].wall;
          this.r2 = this.buildEnv.projLists[i].roof;
          this.f2 = this.buildEnv.projLists[i].floor;
        } else if (i == 2) {
          this.w3 = this.buildEnv.projLists[i].wall;
          this.r3 = this.buildEnv.projLists[i].roof;
          this.f3 = this.buildEnv.projLists[i].floor;
        } else if (i == 3) {
          this.w4 = this.buildEnv.projLists[i].wall;
          this.r4 = this.buildEnv.projLists[i].roof;
        } else if (i == 4) {
          this.w5 = this.buildEnv.projLists[i].wall;
          this.r5 = this.buildEnv.projLists[i].roof;
        } else if (i == 5) {
          this.w6 = this.buildEnv.projLists[i].wall;
        } else if (i == 6) {
          this.w7 = this.buildEnv.projLists[i].wall;
        }

        if (this.toggleStatusNewWind == 'false') {
          document.getElementById('windActText').innerHTML =
            'Include Wind Power - Turn OFF';
        }
        if (this.toggleStatusNewWind == 'true') {
          document.getElementById('windActText').innerHTML =
            'Include Wind Power - Turn ON';
        }

        if (this.toggleStatusNew == 'false') {
          document.getElementById('solarActText').innerHTML =
            'Include Solar PV - Turn OFF';
        }
        if (this.toggleStatusNew == 'true') {
          document.getElementById('solarActText').innerHTML =
            'Include Solar PV - Turn ON';
        }

        
        this.buildEnv.projLists[i].wwr = this.buildEnv.projLists[i].wwr * 100;
        
      }
    });
    this.authService.freshAirData().subscribe((data) => {
      this.freshAir = data;
      this.dhw = this.freshAir && this.freshAir.DHW && this.freshAir.DHW.length > 0 ? this.freshAir.DHW[0] : null;

      
      if (this.freshAir && this.freshAir.success == '1') {
        for (var i = 0; i < this.freshAir.freshAir.length; i++) {
          if (this.freshAir.freshAir[i].fresh_air_type == '1') {
            this.frAirCbPrim = this.freshAir.freshAir[i].custom.slice(0, 1);
          } else if (this.freshAir.freshAir[i].fresh_air_type == '2') {
            this.frAirCbSec = this.freshAir.freshAir[i].custom.slice(0, 1);
          }
        }
      }
      this.applyDhwSelection();
      //  this.custv = data.freshAir.custom;
    });
    this.authService.hvacData().subscribe((data) => {
      this.hvDataCost = data;
      var length = this.hvDataCost.projLists.length;
      this.selectedCustBaseHvac = this.hvDataCost.projLists[length - 1].primcb;
	  if (this.newEmail !== 'demo@ecomatrix.io') {
		this.newcustBaseHvac = this.hvDataCost.projLists[length - 1].primcbName;
	  }
      this.selectedCustBaseHvacName =
        this.hvDataCost.projLists[length - 1].primcbName;
      this.selectedCustBaseHvacSec =
        this.hvDataCost.projLists[length - 1].seccb;
      this.selectedCustBaseHvacSecName =
        this.hvDataCost.projLists[length - 1].seccbName;

      //Get custom baseline DHW values
      this.applyDhwSelection();
      for (var i = 0; i < length; i++) {
        if (this.hvDataCost.projLists[i].hvacSysTypeId === '1') {
          if (
            this.hvDataCost.projLists[i].HVAC_system ===
            this.selectedCustBaseHvacName
          ) {
            this.distCostPrim = this.hvDataCost.projLists[i].distributionCost;
            this.hCostPrim = this.hvDataCost.projLists[i].rate;
            this.cCostPrim = this.hvDataCost.projLists[i].tariff;
          }
        } else if (this.hvDataCost.projLists[i].hvacSysTypeId === '2') {
          this.distCostSec = this.hvDataCost.projLists[i].distributionCost;
          this.hCostSec = this.hvDataCost.projLists[i].rate;
          this.cCostSec = this.hvDataCost.projLists[i].tariff;
        }
      }
    });

    this.authService.freshAirList().subscribe((data) => {
      this.freshAirList = data;
      for (var i = 0; i < this.freshAirList.readData.length; i++) {
        this.freshAirList.readData[i].baseline =
          this.freshAirList.readData[i].baseline.toUpperCase();

        if (this.freshAirList.readData[i].fresh_air_type == '1') {
          this.freshAirPrim.push(this.freshAirList.readData[i]);

          if (
            this.freshAirList.readData[i].active_hvac_system_id ==
            this.selectedCustBaseHvac
          ) {
            //if(this.frAirCbPrim == '1') {
            this.hrYLumpsum = this.freshAirList.readData[i].ERVY_Lumpsum_Cost;

            //  } else {
            this.hrNLumpsum = this.freshAirList.readData[i].ERVN_Lumpsum_Cost;

            //  }
          }
        } else if (this.freshAirList.readData[i].fresh_air_type == '2') {
          this.freshAirSec.push(this.freshAirList.readData[i]);

          if (
            this.freshAirList.readData[i].active_hvac_system_id ==
            this.selectedCustBaseHvacSec
          ) {
            this.hrLumpsumSec =
              this.freshAirList.readData[i].heat_recovery_cost_lumpsum;
          }
        }
      }
      
      //  this.custv = data.freshAir.custom;
    });

    this.authService.lightingData().subscribe((data) => {
      this.lightDataCost = data;
      for (var i = 0; i < this.lightDataCost.projLists.length; i++) {
        if (this.lightDataCost.projLists[i].daylight_sensor == 'DLON') {
          this.lightDataCost.projLists[i].daylight_sensor = 'YES';
        }
        if (this.lightDataCost.projLists[i].daylight_sensor == 'DLOFF') {
          this.lightDataCost.projLists[i].daylight_sensor = 'NO';
        }
      }
      if (this.lightDataCost.projLists[2].ashrae.dls == 'DLOFF') {
        this.lightDataCost.projLists[2].ashrae.dls = 'NO';
      }
      if (this.lightDataCost.projLists[2].ashrae.dls == 'DLON') {
        this.lightDataCost.projLists[2].ashrae.dls = 'YES';
      }

      this.disbwallL = this.lightDataCost.projLists[2].ashrae.lighting;
      this.disbwallNL = this.lightDataCost.projLists[2].necb.lighting;

      this.disbwallD = this.lightDataCost.projLists[2].ashrae.dls;

      this.proposedLight = this.lightDataCost.projLists[3].proposed;
      this.refLight = this.lightDataCost.projLists[3].reference;
      this.proposedLightCost = this.lightDataCost.projLists[3].proposed_cost;
      this.refLightCost = this.lightDataCost.projLists[3].reference_cost;
	   this.newcustBaseLighting =
          this.lightDataCost.projLists[2].custom_baseline.lighting;
		  
		if (this.lightDataCost.projLists[2].custom_baseline.dls == 'DLON') {
          this.newcustBaseDl = 'YES';
        } else {
          this.newcustBaseDl = 'NO';
        }

    });

    this.authService.lightingCostData().subscribe((data) => {
      this.lightData = data;

      for (var i = 0; i < this.lightData.projLists.length; i++) {
        
        if (this.lightData.projLists[i].daylight_sensor == 'DLON') {
          this.lightData.projLists[i].daylight_sensor = 'YES';
          this.lightData.projLists[i].daylight_checked = 'DLON';
        }
        if (this.lightData.projLists[i].daylight_sensor == 'DLOFF') {
          this.lightData.projLists[i].daylight_sensor = 'NO';
          this.lightData.projLists[i].daylight_checked = 'DLOFF';
        }
      }
    });

    this.authService.infiltrationData().subscribe((data) => {
      this.infCostData = data;
	  this.newcustBaseInf =
          this.infCostData.projLists[3].custom_baseline.inf;
      for (var i = 0; i < this.infCostData.projLists.length; i++) {
        this.ashraeInf = this.infCostData.projLists[3].ashrae.inf;
        this.necbInf = this.infCostData.projLists[3].necb.inf;
      }
    });

    this.authService.infCostData().subscribe((data) => {
      this.infData = data;
    });

    this.authService.opCostData().subscribe((data) => {
      this.opCostData = data;
    });

    this.authService.hvacCostData().subscribe((data) => {
      this.hvData = data;

      //this.hvData.projLists.slice(0, length-2);

      //this.newhvData = this.hvData;
      for (var i = 0; i < this.hvData.projLists.length; i++) {
        if (this.hvData.projLists[i].hvacSysTypeId === '1') {
          this.hvDataPrimary.push(this.hvData.projLists[i]);
        } else {
          this.hvDataSec.push(this.hvData.projLists[i]);
        }
      }
     
    });
	this.authService.humidificationData().subscribe((data) => { 
		this.humidification = data.projLists;
		console.log("humidification");
		console.log(this.humidification);
		for (var i = 0; i < this.humidification.length; i++) {
			if (this.humidification[i].hvac_system_id == this.selectedCustBaseHvac) { 
			console.log(this.frAirCbPrim);
			this.humAvlbl = this.humidification[i].hum_avlbl;
				if(this.frAirCbPrim == '1')
					this.humCost = this.humidification[i].ervn_hum_cost;
				else 
					this.humCost = this.humidification[i].ervy_hum_cost;
			}
		}
		
	 })
  } // ng init end
  onBlurGhgCost(fuelSrc) {
    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }

    var cost = document.getElementById('ghgcost-' + fuelSrc).innerHTML;

    if (this.ghgCost != cost) {
      this.CostChanged = 'Y';

      this.isLoading = true;
      const bodyparm = new HttpParams()
        .set('user_id', this.condId)
        .set('proj_id', this.newProjId.toString())
        .set('kpi', 'ghg')
        .set('fuelSrc', fuelSrc)
        .set('cost', cost);
      this.http
        .post(this.rootDomainUrl + 'adeos/api/update_kpi_cost.php', bodyparm)
        .subscribe((data) => {
            this.isLoading = false;
        });
    }
  }
  onBlurOpCost(fuelSrc) {
    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }

    var wincost = document.getElementById('opcost-' + fuelSrc).innerHTML;

    if (this.opCost != wincost) {
      this.CostChanged = 'Y';

      this.isLoading = true;
      const bodyparm = new HttpParams()
        .set('user_id', this.condId)
        .set('proj_id', this.newProjId.toString())
        .set('kpi', 'op')
        .set('fuelSrc', fuelSrc)
        .set('cost', wincost);
      this.http
        .post(this.rootDomainUrl + 'adeos/api/update_kpi_cost.php', bodyparm)
        .subscribe((data) => {
            this.isLoading = false;
        });
    }
  }
  onBlurCarbonTax(fuelSrc) {
    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }

    var wincost = document.getElementById('carbontax-' + fuelSrc).innerHTML;

    if (this.carbonCost != wincost) {
      this.CostChanged = 'Y';

      this.isLoading = true;
      const bodyparm = new HttpParams()
        .set('user_id', this.condId)
        .set('proj_id', this.newProjId.toString())
        .set('kpi', 'carbon')
        .set('fuelSrc', fuelSrc)
        .set('cost', wincost);
      this.http
        .post(this.rootDomainUrl + 'adeos/api/update_kpi_cost.php', bodyparm)
        .subscribe((data) => {
            this.isLoading = false;
        });
    }
  }
  private applyDhwSelection(): void {
    if (
      !this.freshAir ||
      !this.freshAir.DHW ||
      this.freshAir.DHW.length === 0 ||
      !this.selectedCustBaseHvac
    ) {
      return;
    }

    const targetHvacId = String(this.selectedCustBaseHvac).trim();
    let matchedDhw = this.freshAir.DHW[0];

    for (let i = 0; i < this.freshAir.DHW.length; i++) {
      const currentHvacId = String(this.freshAir.DHW[i].active_hvac_system_id || '').trim();
      if (currentHvacId === targetHvacId) {
        matchedDhw = this.freshAir.DHW[i];
        break;
      }
    }

    this.custDHW = matchedDhw;
    this.srcCust = matchedDhw && matchedDhw.dhw_cost !== undefined ? matchedDhw.dhw_cost : '0';
  }

  getGhgCost(id) {
    this.ghgCost = document.getElementById('ghgcost-' + id).innerHTML;
  }
  getOpCost(id) {
    this.opCost = document.getElementById('opcost-' + id).innerHTML;
  }
  getCarbonCost(id) {
    this.carbonCost = document.getElementById('carbontax-' + id).innerHTML;
  }
}
